import types from './types';

const {
  LOAD_PHONE_COUNTRIES, LOAD_PHONE_COUNTRIES_SUCCESS, LOAD_PHONE_COUNTRIES_FAIL,
  VALIDATE_PHONE, VALIDATE_PHONE_SUCCESS, VALIDATE_PHONE_FAIL,
  CLEAR,
} = types;

export const initialState = {
  loading: false,
  loaded: false,
  validating: false,
  validated: false,
  validatingAlternate: false,
  validatedAlternate: false,
  phone: null,
  alternatePhone: null,
  phoneExtensions: [],
  error: {},
  errorAlternate: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_PHONE_COUNTRIES: {
      return {
        ...state,
        loaded: false,
        loading: true,
        error: null,
      };
    }
    case LOAD_PHONE_COUNTRIES_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
        phoneExtensions: action.result,
      };
    case LOAD_PHONE_COUNTRIES_FAIL:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.error,
      };
    case VALIDATE_PHONE: {
      return {
        ...state,
        validating: true,
        validated: false,
        error: {},
        phone: null,
      };
    }
    case VALIDATE_PHONE_SUCCESS:
      return {
        ...state,
        validating: false,
        validated: true,
        phone: action.result,
        error: {},
      };
    case VALIDATE_PHONE_FAIL:
      return {
        ...state,
        validating: false,
        validated: false,
        error: action.error,
      };
    case CLEAR:
      return { ...initialState };
    default:
      return state;
  }
}
